import { Text } from '@thanx/uikit/text'
import HelpIcon from 'assets/images/cms/app-home-page/help.svg'
import Book from 'components/Icons/Book'
import { buildTranslate } from 'locales'
import React from 'react'

type Props = {
  helpUrl: string
  description: string
}

const t = buildTranslate('components.help_center_link')
const HelpCenterLink = ({ helpUrl, description }: Props) => {
  return (
    <div className="mt-l">
      <Text.BodyText4 tag="p" bold className="d-flex">
        <img src={HelpIcon} alt="help" className="mr-xs" />
        {t('help')}
      </Text.BodyText4>

      <a href={helpUrl} target="_blank" rel="noreferrer">
        <Text.BodyText4 tag="p" color="belizeHole50">
          {description}
          <Book className="ml-xs mb-xs" />
        </Text.BodyText4>
      </a>
    </div>
  )
}

export default HelpCenterLink
